export const exteriorView10ImageOptions = {
	angle:"ExteriorView10",
	staticOptions:{
		HullColorways:1,
		Bowsprit:1,
		HullTreatment:1,
		TeakDeck:1,
		TeakOnSideDecks:1,
		BathingPlatform:1,
		SelfTacker:1,
		TeakOnCoachRoof:1,
		MastAndBoom:1,
		BoomCover:1,
		OutboardBracket:1,
		CockpitBenchExtentions:1,
		CockpitCushionBackrests:1,
		CockpitCushionSeats:1,
		CockpitFabric:1,
		SprayhoodFabric:1,
		GTSeat:1,
		Flag:1,
	},
	mattes:[
		{
			option:"HullColorways",
			dependency:null
		},
		{
			option:"Bowsprit",
			dependency:"HullColorways"
		},
		{
			option:"HullTreatment",
			dependency:null
		},
		{
			option:"TeakDeck",
			dependency:"Wheel"
		},
		{
			option:"TeakOnSideDecks",
			dependency:["TeakDeck", "Wheel"]
		},
		{
			option:"SelfTacker",
			dependency:null
		},
		{
			option:"TeakOnCoachRoof",
			dependency:["TeakDeck", "SelfTacker"]
		},
		{
			option:"MastAndBoom",
			dependency:null
		},
		{
			option:"BoomCover",
			dependency:null
		},
		{
			option:"OutboardBracket",
			dependency:null
		},
		{
			option:"CockpitBenchExtentions",
			dependency:["TeakDeck", "CockpitFabric"]
		},
		{
			option:"CockpitCushionBackrests",
			dependency:"CockpitFabric"
		},
		{
			option:"CockpitCushionSeats",
			dependency:["CockpitBenchExtentions", "CockpitFabric"]
		},
		{
			option:"CockpitFabric",
			dependency:null
		},
		{
			option:"GTSeat",
			dependency:"CockpitFabric"
		},
	],
	overlays:[
	]
};



// WEBPACK FOOTER //
// ./src/X46MK2/views/ExteriorView10.js